export const EXPIRATION_DATE_FIELD_ID = 0;
export const START_FIELD_ID = 1;
export const END_FIELD_ID = 2;
export const ONSALE_FIELD_ID = 3;
export const ETICKET_FIELD_ID = 4;
export const FLASH_FIELD_ID = 5;
export const ANNOUNCEMENT_FIELD_ID = 6;
export const ACCESS_START_FIELD_ID = 7;
export const ACCESS_END_FIELD_ID = 8;
export const OFFER_START_FIELD_ID = 9;
export const OFFER_END_FIELD_ID = 10;
export const DOOR_DATE_FIELD_ID = 11;
export const PRICE_CODE_START_FIELD_ID = 12;
export const PRICE_CODE_END_FIELD_ID = 13;
export const STANDARD_DELIVERY_DATE_FIELD_ID = 14;
export const PROMO_VISIBLE_START_DATE = 15;
export const PROMO_VISIBLE_END_DATE = 16;
export const PRICE_LEVEL_START_FIELD_ID = 18;
export const PRICE_LEVEL_END_FIELD_ID = 19;
export const FLASH_SEATS_LIST_EXPIRATION_DATE = 20;

export const ONE_MINUTE = 60;
export const SIXTY_MINUTES = 60 * ONE_MINUTE;
export const TWENTY_FOUR_HOURS = 24 * SIXTY_MINUTES;
export const SEVEN_DAYS = 7 * TWENTY_FOUR_HOURS;
export const FOUR_WEEKS = 4 * SEVEN_DAYS;
export const ONE_MONTH = FOUR_WEEKS;

export const ON_EVENT_START = 0;
export const ON_GENERAL_ONSALE = 1;
export const BEFORE_EVENT_START = 2;
export const BEFORE_GENERAL_ONSALE = 3;
export const AFTER_EVENT_START = 4;
export const AFTER_GENERAL_ONSALE = 5;
export const AFTER_EVENT_END = 17;

export const occurrenceOptions = [
  {
    name: 'Before Event Start',
    id: BEFORE_EVENT_START,
    anchor: START_FIELD_ID,
  },
  { name: 'On Event Start', id: ON_EVENT_START, anchor: START_FIELD_ID },
  { name: 'After Event Start', id: AFTER_EVENT_START, anchor: START_FIELD_ID },
  {
    name: 'Before General Onsale',
    id: BEFORE_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
  { name: 'On General Onsale', id: ON_GENERAL_ONSALE, anchor: ONSALE_FIELD_ID },
  {
    name: 'After General Onsale',
    id: AFTER_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
];

export const announcementDateOccurrenceOptions = [
  {
    name: 'Before General Onsale',
    id: BEFORE_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
  { name: 'On General Onsale', id: ON_GENERAL_ONSALE, anchor: ONSALE_FIELD_ID },
  {
    name: 'After General Onsale',
    id: AFTER_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
];
export const announcementDateOccurrenceOptionsLimit = [
  {
    name: 'Before General Onsale',
    id: BEFORE_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
  { name: 'On General Onsale', id: ON_GENERAL_ONSALE, anchor: ONSALE_FIELD_ID },
];
export const onSaleOccurenceOptions = [
  {
    name: 'Before General Onsale',
    id: BEFORE_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
  {
    name: 'On General Onsale',
    id: ON_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
  {
    name: 'After General Onsale',
    id: AFTER_GENERAL_ONSALE,
    anchor: ONSALE_FIELD_ID,
  },
];

export const listingExpirationDateOccurrenceOptionsLimit = [
  { name: 'On Event Start', id: ON_EVENT_START, anchor: START_FIELD_ID },
  { name: 'After Event Start', id: AFTER_EVENT_START, anchor: START_FIELD_ID },
];

export const listingExpirationDateOccurrenceOptions = [
  {
    name: 'Before Event Start',
    id: BEFORE_EVENT_START,
    anchor: START_FIELD_ID,
  },
  { name: 'On Event Start', id: ON_EVENT_START, anchor: START_FIELD_ID },
  { name: 'After Event Start', id: AFTER_EVENT_START, anchor: START_FIELD_ID },
];

export const editZoneOccurrenceOptions = [
  ...occurrenceOptions,
  {
    name: 'After Event End',
    id: AFTER_EVENT_END,
    anchor: END_FIELD_ID,
  },
];

export const dateFields = [
  { name: 'eventStartDate', id: START_FIELD_ID },
  { name: 'eventEndDate', id: END_FIELD_ID },
  { name: 'generalOnsaleDate', id: ONSALE_FIELD_ID },
  { name: 'eTicketDeliveryDate', id: ETICKET_FIELD_ID },
  { name: 'flashseatsDeliveryDate', id: FLASH_FIELD_ID },
  { name: 'announcementDate', id: ANNOUNCEMENT_FIELD_ID },
  { name: 'accessControlStartDate', id: ACCESS_START_FIELD_ID },
  { name: 'accessControlEndDate', id: ACCESS_END_FIELD_ID },
  { name: 'offerStartDate', id: OFFER_START_FIELD_ID },
  { name: 'offerEndDate', id: OFFER_END_FIELD_ID },
  { name: 'promoVisibleStartDate', id: PROMO_VISIBLE_START_DATE },
  { name: 'promoVisibleEndDate', id: PROMO_VISIBLE_END_DATE },
];

export const timeUnits = [
  { text: 'Minutes', key: 'Minutes', value: 'Minutes' },
  { text: 'Hours', key: 'Hours', value: 'Hours' },
  { text: 'Days', key: 'Days', value: 'Days' },
  { text: 'Weeks', key: 'Weeks', value: 'Weeks' },
];

// Date Field display names.
export const dateFieldNames = {
  [START_FIELD_ID]: 'Event Start',
  [END_FIELD_ID]: 'Event End',
  [ONSALE_FIELD_ID]: 'General Onsale',
  [ETICKET_FIELD_ID]: 'E-Ticket Delivery',
  [FLASH_FIELD_ID]: 'Flash Delivery',
  [ANNOUNCEMENT_FIELD_ID]: 'Announcement',
  [ACCESS_START_FIELD_ID]: 'Access Control Start',
  [ACCESS_END_FIELD_ID]: 'Access Control End',
  [OFFER_START_FIELD_ID]: 'Offer start',
  [OFFER_END_FIELD_ID]: 'Offer End',
  [PROMO_VISIBLE_START_DATE]: 'Promo Visibility Start',
  [PROMO_VISIBLE_END_DATE]: 'Promo Visibility End',
};



// WEBPACK FOOTER //
// ./src/common/components/RelativeDateAndTime/constants/index.js